import Vue from "vue";
import Vuex from "vuex";

import Router from "@/router/index";
import axios from "axios";
import configObject from "@/config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    companyDetails: {},
    dealerDetails: {},
    groupDetails: {},
    pageView: "normal",
    modalShown: false,
    prostatShown: false,
    branchModalShown: false,
    statusInfo: {},
    branchStatusInfo: {},
    showFundWalletModal: true,
    branchTable: null,
    supplyTable: 5,
    userToken: null,
    mobileNavDrawer: false,
    userRole: "customer",
    userInfo: null,
    language: "en",
    country: "NG",
    datePickerColor: "#370f70",
    viewOnly: localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails")).roles.includes(
          "View Only"
        )
      : false,
    countryProducts: localStorage.getItem("countryProducts")
      ? JSON.parse(localStorage.countryProducts)
      : {
          // Products In Portal
          products: {
            product1: "PMS",
            product2: "AGO",
            product3: "DPK",
            product4: "LPG",
            total: "TOTAL",
          },
          productsLower: {
            product1: "pms",
            product2: "ago",
            product3: "dpk",
            product4: "lpg",
          },
          currency: "NGN",
          // currency: '&#8358;'
          // currency: '\uD83D'
        },
    branchTransactions: [],
    branchServiceIds: [],
  },
  getters: {
    getBranchServiceIds(state) {
      return state.branchServiceIds;
    },

    getBanchTransactions(state) {
      return state.branchTransactions;
    },
    getCompanyDetails(state) {
      return state.companyDetails;
    },
    getDealerDetails(state) {
      return state.dealerDetails;
    },
    getGroupDetails(state) {
      return state.groupDetails;
    },
    getPageView(state) {
      return state.pageView;
    },
    getModalShown(state) {
      return state.modalShown;
    },
    getProstatShown(state) {
      return state.prostatShown;
    },
    getBranchModalShown(state) {
      return state.branchModalShown;
    },
    getStatusInfo(state) {
      return state.statusInfo;
    },
    getBranchStatusInfo(state) {
      return state.branchStatusInfo;
    },
    getBranchTable(state) {
      return state.branchTable;
    },
    getSupplyTable(state) {
      return state.supplyTable;
    },
    getShowFundWalletModal: (state) => {
      return state.showFundWalletModal;
    },
    getUserToken: (state) => {
      return state.userToken;
    },
    getMobileNavDrawer(state) {
      return state.mobileNavDrawer;
    },
    getUserRole: (state) => {
      return state.userRole;
    },
    getUserInfo(state) {
      return state.userInfo;
    },
    getLanguage(state) {
      return state.language;
    },
    getCountry(state) {
      return state.country;
    },
    getCountryProducts(state) {
      return state.countryProducts;
    },
    getDatePickerColor(state) {
      return state.datePickerColor;
    },
    getViewOnly(state) {
      return state.viewOnly;
    },
  },
  mutations: {
    setBranchServiceIds(state, payload) {
      state.branchServiceIds = payload;
    },

    removeBranchServiceIds(state, payload) {
      state.branchServiceIds.splice(payload, 1);
    },
    setBanchTransactions(state, payload) {
      state.branchTransactions = payload;
    },
    removeBanchTransactions(state, payload) {
      state.branchTransactions.splice(payload, 1);
    },
    setCompanyDetails(state, payload) {
      state.companyDetails = payload;
    },
    setDealerDetails(state, payload) {
      state.dealerDetails = payload;
    },
    setGroupDetails(state, payload) {
      state.groupDetails = payload;
    },
    setPageView(state, payload) {
      state.pageView = payload;
    },
    setModalShown(state, payload) {
      state.modalShown = payload;
    },
    setProstatShown(state, payload) {
      state.prostatShown = payload;
    },
    setBranchModalShown(state, payload) {
      state.branchModalShown = payload;
    },
    setStatusInfo(state, payload) {
      state.statusInfo = payload;
    },
    setBranchStatusInfo(state, payload) {
      state.branchStatusInfo = payload;
    },
    setBranchTable(state, payload) {
      state.branchTable = payload;
    },
    setSupplyTable(state, payload) {
      state.supplyTable = payload;
    },
    setUserRole(state, payload) {
      state.userRole = payload.userRole;
    },
    toggleLoginModal(state) {
      state.showFundWalletModal = !state.showFundWalletModal;
    },
    changeUserToken(state, payload) {
      state.userToken = payload.userToken;
    },
    toggleMobileNavDrawer(state) {
      state.mobileNavDrawer = !state.mobileNavDrawer;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setLanguage(state, payload) {
      state.language = payload;
    },
    setCountry(state, payload) {
      state.country = payload;
    },
    setCountryProducts(state, payload) {
      state.countryProducts = payload;
    },
    setDatePickerColor(state, payload) {
      state.datePickerColor = payload;
    },
    setBaseLocale(state, payload) {
      state.language = payload.split("-")[0];
      state.country = payload.split("-")[1];
    },
    setViewOnly(state, payload) {
      state.viewOnly = payload;
    },
  },
  actions: {
    logout() {
      localStorage.clear();
      Router.push({ name: "login" });
    },
  },
  modules: {},
});
